import WebSocketScaleClient from './ws-scale-client';

export const getScaleSocketInstance = () => {
    if (!window.scaleSocketClient) {
        let socketClient = null;
        socketClient = new WebSocketScaleClient();
        window.scaleSocketClient = socketClient;
    }
    return window.scaleSocketClient ? window.scaleSocketClient : null;
}